import { BALANCE_VALUATIONS } from "../constants";

const initialState = {
  balance_index: {},
  balance_show: {},
  balance_detail: {},
  balance_valuations: {}
};

export default function balanceReducer(state = initialState, action) {
  switch (action.type) {
    case "BALANCE_INDEX":
      return Object.assign({}, state, {
        balance_index: action.payload
      });
    case "BALANCE_SHOW":
      return Object.assign({}, state, {
        balance_show: action.payload
      });
    case "BALANCE_SHOW_FORM":
      return Object.assign({}, state, {
      balance_show: {
        ...state.balance_show,
        form: action.payload.form,
        multiple_new: action.payload.multiple_new,
        actions: action.payload.actions
      }
    });   
    case "BALANCE_DETAIL":
      return Object.assign({}, state, {
        balance_detail: action.payload
      });
    case "UPDATE_ASSETS":
      return Object.assign({}, state, {
        balance_detail: action.response
      });
    case BALANCE_VALUATIONS:
      return Object.assign({}, state, {
        balance_valuations: action.payload
      });
    case "BALANCE_DETAIL_TAB": 
      return {
      ...state,
      balance_detail: {
        ...state.balance_detail,
        tablesv2: {
          ...state.balance_detail.tablesv2,
          [action.source]: {
            ...state.balance_detail.tablesv2[action.source],
            rows: Object.keys(action.payload).length === 0 ? [] : state.balance_detail.tablesv2[action.source].rows
          },
          ...action.payload
        },
        force_update: state.balance_detail.force_update !== undefined ? !state.balance_detail.force_update : true
      }
    };
    default:
      return state;
  }
}
